// extracted by mini-css-extract-plugin
module.exports = {"onBehalfControls":"OnbehalfControls_onBehalfControls__r2gH_","select":"OnbehalfControls_select__1iz-j"};